import { useUnit } from 'effector-react';
import $$auth from 'models/auth';
import { useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';

import HookFormControl from 'components/HookFormControl';
import CommunityTab from 'components/StyledTemplates/CommunityTab';

import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

const ChangeEmail = () => {
    const { t } = useResources();
    const form = useForm();

    const [loading, setLoading] = useState(false);

    const user = useUnit($$auth.$currentParticipant);

    const handleSubmit = async (event: any) => {
        setLoading(true);
        ParticipantsService.setNewUserEmail(event?.newEmail).finally(() => setLoading(false));
    };

    return (
        <FormProvider {...form}>
            <Form onSubmit={form.handleSubmit(handleSubmit)}>
                <CommunityTab title={t(`changeEmail.change_email`)} extraBody="display: block !important;">
                    <Form.Row>
                        <Form.Group as={Col} sm={12} controlId="currentEmail">
                            <Form.Label>{t(`changeEmail.currentEmail`, { email: user?.email ?? `` })}</Form.Label>
                        </Form.Group>
                        <Form.Group as={Col} sm={12} controlId="newEmail">
                            <HookFormControl.Email
                                name="newEmail"
                                label={t(`changeEmail.new_email`)}
                                rules={{ required: t(`changeEmail.new_email_error`) }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <div className="text-right mt-3">
                        <Button
                            data-qaid="change_button"
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            className="px-5"
                        >
                            {t(`changeEmail.change`)}{' '}
                            {loading && (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                        </Button>
                    </div>
                </CommunityTab>
            </Form>
        </FormProvider>
    );
};

export default ChangeEmail;
